import { render, staticRenderFns } from "./BrandCreateDialog.vue?vue&type=template&id=238fed06&scoped=true"
import script from "./BrandCreateDialog.vue?vue&type=script&lang=ts"
export * from "./BrandCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238fed06",
  null
  
)

export default component.exports